module.exports = __webpack_public_path__ + "media/images/emoticons/recycle-d876aa720e71c6895a0215bd7da733c1.gif";